/**
 * Labstep
 *
 * @module components/ProtocolValue/Check
 * @desc Experiment Value item
 */

import { ProtocolValueAmountUpdateStatus } from 'labstep-web/components/ProtocolValue/AmountUpdateStatus';
import { ProtocolValueCheckResourceItemOutput } from 'labstep-web/components/ProtocolValue/Check/ResourceItemOutput';
import type React from 'react';
import type { IProtocolValueCheckProps } from './types';

export const ProtocolValueCheck: React.FC<
  IProtocolValueCheckProps
> = ({ protocolValue }) =>
  protocolValue.is_input ? (
    <ProtocolValueAmountUpdateStatus
      protocolValue={protocolValue}
      showNotSpecifiedIfApplicable
    />
  ) : (
    <ProtocolValueCheckResourceItemOutput
      protocolValue={protocolValue}
    />
  );
